module.exports = "/fonts/developer-picturemark-l-0eea0c16939cd16c785542a713d585fe.svg";